var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a',{staticClass:"play-button",on:{"click":function($event){$event.preventDefault();return _vm.playQueuedAudioFile.apply(null, arguments)}}},[_c('IconPlay')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }